require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/$.core').Number.isNaN;


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/~/core-js/library/fn/number/is-nan.js
 ** module id = 284
 ** module chunks = 0
 **/